import { useTranslation } from 'react-i18next'
import useNotifications from '../../hooks/useNotifications'
import { getTreeGroups } from '../../services/treeService'

export default function useTreeGroups(treeId, setTree) {
  const { t } = useTranslation()
  const { error } = useNotifications()

  const fetchTreeGroups = async () => {
    await getTreeGroups(treeId)
      .then((groupsResponse) => {
        setTree((prevState) => {
          return { ...prevState, groups: groupsResponse.data }
        })
      })
      .catch((err) => {
        error(`${t('tree.error.groups', 'Error getting groups for tree')} ${treeId}: ${err.message || ''}`, err)
      })
  }

  return { fetchTreeGroups }
}
